import { TVTREM_KEY, TVTRM_KEY } from 'pages/Valuations/approaches/discountCashFlow/dcf/config/constants';
import { extractSpecificApproachFromApproach } from 'pages/ValuationsAllocation/util/extractSpecificApproachFromApproach';
import { getCompaniesOrTransactions } from 'pages/ValuationsAllocation/util/getCompaniesOrTransactions';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';
import { getTVTsThatDependOnBenchmark } from 'pages/ValuationsAllocation/util/getTVTsThatDependOnBenchmark';
import { getNumberValue, getObjectValue, getStringValue } from 'utillities';
import { GetRowConfigToUpdateParams, UpdateDCFOptionsParams } from './types';

const getRowConfigToUpdate = (params: GetRowConfigToUpdateParams) => {
  const { spreadsheetKey, DCFRowConfigs } = params;

  const { revenueRowConfig, ebitdaRowConfig, revenueAndEbitdaRowConfig } = getObjectValue(DCFRowConfigs);

  switch (spreadsheetKey) {
    case TVTRM_KEY:
      return revenueRowConfig;

    case TVTREM_KEY:
      return revenueAndEbitdaRowConfig;

    default:
      return ebitdaRowConfig;
  }
};

export const updateDCFOptions = (params: UpdateDCFOptionsParams) => {
  const { DCFSpreadsheets, benchmarkApproach, DCFRowConfigs } = params;

  const specificApproach = extractSpecificApproachFromApproach(benchmarkApproach);
  const { percentile_selection_a: percentileSelectionA, percentile_selection_b: percentileSelectionB }
    = getObjectValue(specificApproach);

  const optionsInBenchmark = getSelectionCellOptions({
    isDCF: true,
    specificApproach,
  });

  const companiesRows = getCompaniesOrTransactions(specificApproach);

  const spreadsheetsToUpdate = getTVTsThatDependOnBenchmark(DCFSpreadsheets);

  spreadsheetsToUpdate.forEach(spreadsheet => {
    const [spreadsheetKey, spreadsheetConfig] = spreadsheet;

    const rowConfigArguments = {
      benchmarkType: benchmarkApproach?.approach_type,
      companiesRows,
      dcfWaccSheet: DCFSpreadsheets?.dcfWacc,
      mainTableName: getStringValue(DCFSpreadsheets?.dcf?.name),
      options: optionsInBenchmark,
      percentileSelections: {
        percentile_selection_a: getNumberValue(percentileSelectionA),
        percentile_selection_b: getNumberValue(percentileSelectionB),
      },
    };

    const rowConfigToUpdate = getRowConfigToUpdate({ spreadsheetKey, DCFRowConfigs });
    const updatedRowConfig = rowConfigToUpdate?.(rowConfigArguments);

    spreadsheetConfig.reset({ rowConfig: updatedRowConfig });
  });
};

export default updateDCFOptions;
